const getRelativePosition = el1 => {
  const dimension1 = el1.getBoundingClientRect();
  return {
    x: dimension1.x - (100 - dimension1.width) / 2,
    y: dimension1.top - 55 - 2
  };
};

export default getRelativePosition;



// WEBPACK FOOTER //
// ./src/helpers.js